export default "__VITE_ASSET__9de8d9d1__"